module.exports = require("cytoscape-node-editing");